module.exports = __webpack_public_path__ + "img/tour-60.faa3b4be.png";